import { gql } from "@apollo/client";

// TODO: Implement fragments: https://www.apollographql.com/docs/react/advanced/fragments.html
// Pay attention to Webpack instructions for loading fragments: https://www.apollographql.com/docs/react/recipes/webpack.html
// https://github.com/detrohutt/babel-plugin-import-graphql

export const mention = gql`
  fragment Mention on Mention {
    id
    userId
    username
    startPosition
    endPosition
  }
`;

export const hashtag = gql`
  fragment Hashtag on Hashtag {
    id
    hashtagId
    isActive
    name
    startPosition
    endPosition
  }
`;

export const url = gql`
  fragment Url on Url {
    id
    url
    startPosition
    endPosition
  }
`;

export const user = gql`
  fragment User on User {
    id
    avatarBucketName
    avatarContentType
    avatarFileName
    avatarPostId
    avatarTop
    avatarLeft
    avatarWidth
    avatarHeight
    avatarRotation
    currentPostStreak
    followerCount
    followingCount
    isActive
    isBlocked
    isBlocker
    isRequestingFollow
    isFollowRequested
    isFollower
    isFollowing
    isOnboarded
    isPrivate
    isReported
    isVerified
    isWatching
    maxPostWindowUnusedPercent
    name
    postCount
    postLikeCount
    postStreakRecord
    postViewCount
    commentCount
    profileDescription
    username
    verificationIdentity
    hashtags {
      ...Hashtag
    }
    mentions {
      ...Mention
    }
    urls {
      ...Url
    }
  }
  ${hashtag}
  ${mention}
  ${url}
`;

// Changes to post fields should also be reflected in components.js SavePost
export const post = gql`
  fragment Post on Post {
    id
    commentCount
    commentsEnabled
    contentBucketName
    contentFileName
    contentHeight
    contentMimeType
    contentOrientation
    contentType
    contentUrl
    contentWidth
    createdDate
    didComment
    isActive
    isHidden
    isOptimistic
    isReported
    likeCount
    liked
    thumbnailBucketName
    thumbnailFileName
    thumbnailUrl
    title
    text
    viewCount
    hashtags {
      ...Hashtag
    }
    mentions {
      ...Mention
    }
    urls {
      ...Url
    }
    user {
      ...User
    }
  }
  ${hashtag}
  ${mention}
  ${url}
  ${user}
`;
const commentFields = gql`
  fragment CommentFields on Comment {
    id
    commentBody
    createdDate
    isActive
    isHidden
    isOptimistic
    isReported
    likeCount
    liked
    replyCount
    hashtags {
      ...Hashtag
    }
    mentions {
      ...Mention
    }
    urls {
      ...Url
    }
    user {
      ...User
    }
    replyToUser {
      ...User
    }
  }
  ${hashtag}
  ${mention}
  ${url}
  ${user}
`;

// FIXME: Hot dumpster fire kluge to allow the recursive structure of comment replies.
const commentsRecursive = gql`
  fragment CommentsRecursive on Comment {
    replies {
      ...CommentFields
      replies {
        ...CommentFields
        replies {
          ...CommentFields
          replies {
            ...CommentFields
            replies {
              ...CommentFields
              replies {
                ...CommentFields
                replies {
                  ...CommentFields
                  replies {
                    ...CommentFields
                    replies {
                      ...CommentFields
                      replies {
                        ...CommentFields
                        replies {
                          ...CommentFields
                          replies {
                            ...CommentFields
                            replies {
                              ...CommentFields
                              replies {
                                ...CommentFields
                                replies {
                                  ...CommentFields
                                  replies {
                                    ...CommentFields
                                    replies {
                                      ...CommentFields
                                      replies {
                                        ...CommentFields
                                        replies {
                                          ...CommentFields
                                          replies {
                                            ...CommentFields
                                            replies {
                                              ...CommentFields
                                              replies {
                                                ...CommentFields
                                                replies {
                                                  ...CommentFields
                                                  replies {
                                                    ...CommentFields
                                                    replies {
                                                      ...CommentFields
                                                      replies {
                                                        ...CommentFields
                                                        replies {
                                                          ...CommentFields
                                                          replies {
                                                            ...CommentFields
                                                            replies {
                                                              ...CommentFields
                                                              replies {
                                                                ...CommentFields
                                                                replies {
                                                                  ...CommentFields
                                                                  replies {
                                                                    ...CommentFields
                                                                    replies {
                                                                      ...CommentFields
                                                                      replies {
                                                                        ...CommentFields
                                                                        replies {
                                                                          ...CommentFields
                                                                          replies {
                                                                            ...CommentFields
                                                                            replies {
                                                                              ...CommentFields
                                                                              replies {
                                                                                ...CommentFields
                                                                                replies {
                                                                                  ...CommentFields
                                                                                  replies {
                                                                                    ...CommentFields
                                                                                    replies {
                                                                                      ...CommentFields
                                                                                      replies {
                                                                                        ...CommentFields
                                                                                        replies {
                                                                                          ...CommentFields
                                                                                          replies {
                                                                                            ...CommentFields
                                                                                            replies {
                                                                                              ...CommentFields
                                                                                              replies {
                                                                                                ...CommentFields
                                                                                                replies {
                                                                                                  ...CommentFields
                                                                                                  replies {
                                                                                                    ...CommentFields
                                                                                                    replies {
                                                                                                      ...CommentFields
                                                                                                      replies {
                                                                                                        ...CommentFields
                                                                                                        replies {
                                                                                                          ...CommentFields
                                                                                                          replies {
                                                                                                            ...CommentFields
                                                                                                            replies {
                                                                                                              ...CommentFields
                                                                                                            }
                                                                                                          }
                                                                                                        }
                                                                                                      }
                                                                                                    }
                                                                                                  }
                                                                                                }
                                                                                              }
                                                                                            }
                                                                                          }
                                                                                        }
                                                                                      }
                                                                                    }
                                                                                  }
                                                                                }
                                                                              }
                                                                            }
                                                                          }
                                                                        }
                                                                      }
                                                                    }
                                                                  }
                                                                }
                                                              }
                                                            }
                                                          }
                                                        }
                                                      }
                                                    }
                                                  }
                                                }
                                              }
                                            }
                                          }
                                        }
                                      }
                                    }
                                  }
                                }
                              }
                            }
                          }
                        }
                      }
                    }
                  }
                }
              }
            }
          }
        }
      }
    }
  }
  ${commentFields}
`;

export const comment = gql`
  fragment Comment on Comment {
    ...CommentFields
    ...CommentsRecursive
  }
  ${commentFields}
  ${commentsRecursive}
`;

export const postWindow = gql`
  fragment PostWindow on PostWindow {
    createdDate
    id
    isActive
    isUsed
    postWindowClose
    postWindowDuration
    postWindowOpen
    postWindowRemaining
    postWindowUnusedPercent
    isPushNotificationOpenedOnDevice
    pushNotificationOpenedOnDeviceDate
    serverTime
  }
`;

export const alert = gql`
  fragment Alert on Alert {
    id
    alertType
    users {
      ...User
    }
    totalUsers
    posts {
      ...Post
    }
    comments {
      ...Comment
    }
    createdDate
    updatedDate
    isActive
    isHidden
    isRead
  }
  ${user}
  ${post}
  ${comment}
`;

export const unreadAlertCount = gql`
  fragment UnreadAlertCount on UnreadAlertCount {
    id
    count
  }
`;
